var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(this.$i18n.locale == 'ar')?_c('img',{staticClass:"imgs",attrs:{"src":require("../../assets/banner/arBannerD.png"),"alt":""}}):_c('img',{staticClass:"imgs",attrs:{"src":require("../../assets/banner/enBannerD.png"),"alt":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }